// Define a service holding the language. You probably already have one if your app is i18ned. Or you could also

import { inject, Injectable } from '@angular/core';
import { NgbDatepickerI18n, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

// use the Angular LOCALE_ID value
@Injectable()
export class I18n {
  language = 'vi';
}

// Define custom service providing the months and weekdays translations
@Injectable()
export class CustomGlobalDatepickerI18n extends NgbDatepickerI18n {
  private _i18n = inject(I18n);
  private I18N_VALUES: { [lang: string]: any } = {
    vi: {
      weekdays: ['T2', 'T3', 'T4', 'T5', 'T6', 'T7', 'CN'],
      months: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
      weekLabel: 'Tuần',
    },
    // other languages you would support
  };

  getWeekdayLabel(weekday: number): string {
    return this.I18N_VALUES[this._i18n.language].weekdays[weekday - 1];
  }
  override getWeekLabel(): string {
    return this.I18N_VALUES[this._i18n.language].weekLabel;
  }
  getMonthShortName(month: number): string {
    return this.I18N_VALUES[this._i18n.language].months[month - 1];
  }
  getMonthFullName(month: number): string {
    return this.getMonthShortName(month);
  }
  getDayAriaLabel(date: NgbDateStruct): string {
    return `${date.day}-${date.month}-${date.year}`;
  }
}

// Define custom service providing the months and weekdays translations
@Injectable()
export class CustomFlightDatepickerI18n extends NgbDatepickerI18n {
  private _i18n = inject(I18n);
  private I18N_VALUES: { [lang: string]: any } = {
    vi: {
      weekdays: ['Thứ 2', 'Thứ 3', 'Thứ 4', 'Thứ 5', 'Thứ 6', 'Thứ 7', 'CN'],
      months: [
        'Tháng 1',
        'Tháng 2',
        'Tháng 3',
        'Tháng 4',
        'Tháng 5',
        'Tháng 6',
        'Tháng 7',
        'Tháng 8',
        'Tháng 9',
        'Tháng 10',
        'Tháng 11',
        'Tháng 12',
      ],
      weekLabel: 'Tuần',
    },
    // other languages you would support
  };

  getWeekdayLabel(weekday: number): string {
    return this.I18N_VALUES[this._i18n.language].weekdays[weekday - 1];
  }

  override getWeekLabel(): string {
    return this.I18N_VALUES[this._i18n.language].weekLabel;
  }

  getMonthShortName(month: number): string {
    return this.I18N_VALUES[this._i18n.language].months[month - 1];
  }

  getMonthFullName(month: number): string {
    return this.getMonthShortName(month);
  }

  getDayAriaLabel(date: NgbDateStruct): string {
    return `${date.day}-${date.month}-${date.year}`;
  }
}
